import IsochroneHandler from "../../map/IsochroneHandler";
import MapHandler from "../../map/MapHandler";

export default class IsochroneLocation {
  #isochroneHandler: IsochroneHandler;
  #timerId!: number;

  #oldX;
  #oldAngle;

  constructor(isochroneHandler: IsochroneHandler) {
    this.#isochroneHandler = isochroneHandler;
    this.#oldX = -1;
    this.#oldAngle = -1;
  }

  onAddObject(evt: any, maphandler: MapHandler) {
    this.#isochroneHandler.setMap(maphandler.getMap());
  }

  onUpdateObject(evt: any) {
    if (this.#oldX !== evt.xPos || this.#oldAngle !== evt.angle) {
      this.#oldX = evt.xPos;
      this.#oldAngle = evt.angle;

      const timerCallBack = () => {
        var collapsibleContent = $(".collapsible-content");
        var selectedTab = collapsibleContent
          .find(".tab.selected")
          .siblings(".slider-wrapper")
          .find(".tab-item");
        var profile = $(selectedTab[0]).find("select").val();
        var rangeType = $(selectedTab[1]).find("input:checked").val();
        var metric = rangeType === "time" ? "sec" : "meter";

        var range: number = Number(
          collapsibleContent
            .find(".tab.selected")
            .siblings(".slider-wrapper")
            .find(".desc > .x")
            .text()
        );
        range = metric === "sec" ? range * 60 : range;
        var relativeX = evt.xPos;
        var relativeY = evt.yPos;

        if (!profile || !metric || !range || !relativeX || !relativeY) {
          return;
        }
        this.#isochroneHandler.removeIsochrone("isochronePoi");
        this.#isochroneHandler.removeIsochrone("location" + evt.symbolId);
        this.#isochroneHandler.drawPoiIsochrone();
        this.#isochroneHandler.computeIsochrone(
          evt.symbolId,
          profile,
          metric,
          range,
          relativeX,
          relativeY
        );
      };
      this.resetTimer(timerCallBack);
    }
  }

  onRemoveObject(evt: any) {
    clearTimeout(this.#timerId);
    this.#isochroneHandler.removeIsochrone("isochronePoi");
    this.#isochroneHandler.removeIsochrone("location" + evt.symbolId);

    var collapsibleContent = $(".collapsible-content");
    var selectedTab = collapsibleContent
      .find(".tab.selected")
      .siblings(".slider-wrapper")
      .find(".tab-item");
    if (selectedTab.length > 0) {
      this.#isochroneHandler.drawPoiIsochrone();
    }
  }

  resetTimer(timerCallBack: Function) {
    clearTimeout(this.#timerId);
    this.#timerId = setTimeout(timerCallBack, 500);
  }
}
